import React, { useEffect } from 'react';
import { HashRouter } from 'react-router-dom';
import { create } from 'jss';
import rtl from 'jss-rtl';
import { SnackbarProvider } from 'notistack';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import GlobalStyles from 'src/components/GlobalStyles';
import ScrollReset from 'src/components/ScrollReset';
import GoogleAnalytics from 'src/components/GoogleAnalytics';
import useSettings from 'src/hooks/useSettings';
import { createTheme } from 'src/theme';
import routes, { renderRoutes } from 'src/routes';
import { useDispatch, useSelector } from 'src/store';
import { fetchUser } from './slices/auth';
import { getSystemSettings } from './slices/user';
import SplashScreen from 'src/components/SplashScreen';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const App = () => {
  const { settings } = useSettings();
  const dispatch = useDispatch();
  const { isInitialised } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchUser());
    dispatch(getSystemSettings());
  }, []);

  if (!isInitialised) {
    return <SplashScreen />;
  }

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme
  });

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider
            dense
            maxSnack={3}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          >
            <HashRouter>
              <GlobalStyles />
              <ScrollReset />
              <GoogleAnalytics />
              {renderRoutes(routes)}
            </HashRouter>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
